import { isEmpty } from '@app/utils/isEmpty';
import { Modals } from '@typings';

export const getIsModalVisible = (modalName: Modals.Type) => (store: Store) => !!store.ui.visibleModals.includes(modalName);
export const getIsAnyModalVisible = (store: Store) => !isEmpty(store.ui.visibleModals);

export const getIsUserOffline = (state: Store): boolean => state.ui.isOffline;

export const getIsSavingAnything = (state: Store): boolean => state.ui.isSaving;

export const getIsOrderSettingsFormDisabled = (state: Store): boolean => state.ui.isOrderSettingsFormDisabled;

export const getProductsGridSize = (state: Store) => state.ui.productsGridSize;
export const getIsProductsGridView = (state: Store) => state.ui.isProductsGridView;

export const getIsSoftLogoutMode = (state: Store) => state.ui.isSoftLogoutMode;

export const getShouldShowMoreShippingAddresses = (state: Store) => state.ui.shouldShowMoreShippingAddresses;

export const getLanguageToSet = (state: Store) => state.ui.languageToSet;

export const getIsMatrixTotalsColumnPinned = (state: Store) => state.ui.isMatrixTotalsColumnPinned;

export const getIsMenuOpen = (state: Store) => state.ui.isMenuOpen;

export const getLookbookProductsGridSize = (state: Store) => state.ui.lookbookProductsGridSize;
